(function ($) {
	'use strict';

	var Timer = function(options) {
		$.extend(this, options);

		var date = new Date(this.$el.data('date'));

		this.opts.end = isNaN(+date) ? new Date() :  date;

		this.updateTime().tick();

		return this;
	};

	Timer.prototype.updateTime = function() {
		var now       = new Date(),
			end       = this.opts.end,

			time_left = end - now,
			time_left = time_left < 0 ? 0 : time_left,

			millis    = parseInt(time_left / 1000),
			days      = Math.floor(millis / 3600 / 24),
			hours     = Math.floor(millis / 3600 % 24),
			minutes   = Math.floor(millis / 60 % 60),
			seconds   = Math.floor(millis % 60);

		this.opts.end_time = {
			day : days,
			hr  : hours,
			min : minutes,
			sec : seconds
		};

		return this;
	};

	Timer.prototype.tick = function() {

		var html = this.getItemHTML();

		this.$el.html(html);
		this.$el.trigger('tick');

		if(!this.isComplete()) {
			this.updateCircle().updateTime();
			setTimeout(this.tick.bind(this), this.opts.interval);

			return this;
		}

		this.$el.trigger('complete');

		return this;
	};

	Timer.prototype.getItemHTML = function() {
		var data = {
			value: '',
			label: ''
		};

		if (this.opts.end_time.day) {
			data.value = this.opts.end_time.day;
			data.label = 'Day';
		}
		else if (this.opts.end_time.hr) {
			data.value = this.opts.end_time.hr;
			data.label = 'Hour';
		}
		else if (this.opts.end_time.min) {
			data.value = this.opts.end_time.min;
			data.label = 'Min';
		}
		else {
			data.value = this.opts.end_time.sec;
			data.label = 'Sec';
		}

		data.label += data.value > 1 ? 's' : '';

		return this.opts.template(data);
	};

	Timer.prototype.isComplete = function() {
		function accumulate(prev, next_key){
			return prev + time[next_key];
		}

		var time = this.opts.end_time,
			keys = Object.keys(time);

		return !keys.reduce(accumulate, 0);
	};

	Timer.prototype.updateCircle = function() {
		var now    = new Date(),
			canvas = this.$el.find('canvas')[0],
			ctx    = canvas.getContext('2d');

		// BG Circle
		ctx.lineWidth = this.opts.line_width;
		ctx.strokeStyle = this.opts.bg_color;
		ctx.beginPath();
		ctx.arc(30, 30, 25, 0, 2*Math.PI, false);
		ctx.stroke();
		ctx.closePath();

		if (now > this.opts.start) {
			var total_time   = this.opts.end - this.opts.start,
				current_time = now - this.opts.start,
				end_angle    = current_time * Math.PI * 2 / total_time;

			// Progress Circle
			ctx.lineWidth = this.opts.line_width;
			ctx.strokeStyle = this.opts.progress_color;
			ctx.beginPath();
			ctx.arc(30, 30, 25, 0, end_angle, false);
			ctx.stroke();
			ctx.closePath();
		}

		return this;
	};

	$.fn.circleTimer = function (options) {
		return this.each(function() {
			var opts = $.extend({}, $.fn.circleTimer.defaults, options);

			new Timer({
				$el:  $(this),
				opts: opts
			});
		});
	};

	// Simple JavaScript Templating
	// John Resig - http://ejohn.org/ - MIT Licensed
	$.fn.circleTimer.template = (function(){
		var cache = {};

		return function tmpl(str, data){
			// Figure out if we're getting a template, or if we need to
			// load the template - and be sure to cache the result.
			var fn = !/\W/.test(str) ?
				cache[str] = cache[str] ||
					tmpl(document.getElementById(str).innerHTML) :

				// Generate a reusable function that will serve as a template
				// generator (and which will be cached).
				new Function("obj",
					"var p=[],print=function(){p.push.apply(p,arguments);};" +

						// Introduce the data as local variables using with(){}
					"with(obj){p.push('" +

						// Convert the template into pure JavaScript
					str
						.replace(/[\r\t\n]/g, " ")
						.split("<%").join("\t")
						.replace(/((^|%>)[^\t]*)'/g, "$1\r")
						.replace(/\t=(.*?)%>/g, "',$1,'")
						.split("\t").join("');")
						.split("%>").join("p.push('")
						.split("\r").join("\\'")
					+ "');}return p.join('');");

			// Provide some basic currying to the user
			return data ? fn( data ) : fn;
		};
	})();

	$.fn.circleTimer.defaults = {
		bg_color:       '#0f7ad2',
		progress_color: '#528f20',
		line_width:     5,
		interval:       1000,
		template:       $.fn.circleTimer.template(
			'<div class="time_circles">' +
			'  <canvas width="60" height="60"></canvas>' +
			'  <div class="time_circles-content">' +
			'    <span class="time_circles-value"><%= value %></span>' +
			'    <h4 class="time_circles-label"><%= label %></h4>' +
			'  </div>' +
			'</div>'
		)
	};

}(jQuery));